module.exports = __webpack_public_path__ + "media/car.b6c6c386.ogg";